module.exports = __webpack_public_path__ + "assets/img/icon-upload-success.69b7443b.png";